/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';

export const postgroups = (state = defaultState.postgroups, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        postgroups = [];

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.POSTGROUP_LIST:
                nextState = action.payload;
                break;

            case constants.POSTGROUP_SHOW:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) === parseInt(action.payload.id, 10)) {
                        nextState[i] = action.payload;
                        break;
                    }
                }
                break;

            case constants.POSTGROUP_UPDATE:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) === parseInt(action.payload.id, 10)) {
                        nextState[i] = action.payload;
                        break;
                    }
                }
                break;

            case constants.POSTGROUP_DELETE:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) !== parseInt(action.payload.id, 10)) {
                        postgroups.push(nextState[i]);
                    }
                }
                nextState = postgroups;
                break;

            case constants.POSTGROUP_CREATE:
                nextState.push(action.payload);
                break;

            default:
                break;
        }
    }

    return nextState;
};
